import React from 'react';
import PropTypes from 'prop-types';
// import {Tabs, Tab} from "material-ui";
import {renderGraphQLStatusOrNull} from "../../utils/utils";
import {compose} from 'react-apollo';
import queries from "../../graphql/queries";
// import StatesDaysHistogram from "./StatesDaysHistogram";
import StatesAnalytics from "./StatesAnalytics";
import './Analytics.css';

export default compose(
    queries.projectQueryHocWithName("projectData"),
)(class Analytics extends React.Component {

    static propTypes = {
        params: PropTypes.shape({
            projectId: PropTypes.string.isRequired
        }).isRequired,
        projectData: PropTypes.object.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let gqlStatus = renderGraphQLStatusOrNull([this.props.projectData]);
        if (gqlStatus !== null) {
            return gqlStatus;
        }
        return (
            <div className="analyticsContainer">
                <h2>Analytics</h2>
                <StatesAnalytics project={this.props.projectData.project}/>
                {/*<Tabs inkBarStyle={{height: 4, marginTop: -4}} contentContainerClassName="analyticsTabsContentContainer">*/}
                    {/*<Tab label="Histogram">*/}
                        {/*<StatesDaysHistogram project={this.props.projectData.project}/>*/}
                    {/*</Tab>*/}
                {/*</Tabs>*/}
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/analytics/Analytics.js